import React from 'react';
import { ReactComponent as Seat } from '@weezevent/throne/dist/images/seating/siege-available.svg';
import css from '../Seatmap/seat-map.module.css';

function SeatIcon({ name, color, id }) {
    return (
        <>
            <style>{`svg.rate-seat-icon-${id} path {
                fill: ${color} !important;
            }`}</style>

            <div className={css['summary-item-icon']}>
                <Seat className={`${css['selected-seat-icon']} rate-seat-icon-${id}`} />
                <span>{name}</span>
            </div>
        </>
    );
}

export default SeatIcon;
